import { LabelValue } from "newui/types/LabelValue.type";

export const USER_ROLE_NAMES = {
	USER: "user",
	GUEST: "guest",
	COMPANY_ADMIN: "company_admin",
};

export const USER_ROLES = [
	{ id: 3, name: USER_ROLE_NAMES.USER, label: "User" },
	{ id: 4, name: USER_ROLE_NAMES.GUEST, label: "Guest" },
	{ id: 5, name: USER_ROLE_NAMES.COMPANY_ADMIN, label: "Administrator" },
] as const;

export const USER_ROLES_FOR_SELECTION = USER_ROLES.filter(
	(role) => role.name !== USER_ROLE_NAMES.GUEST
).map(
	(role) =>
		({
			value: role.name,
			label: role.label,
		}) as LabelValue<string>
);

export const USER_ROLE = {
	USER: USER_ROLES.find((r) => r.name === USER_ROLE_NAMES.USER)!,
	GUEST: USER_ROLES.find((r) => r.name === USER_ROLE_NAMES.GUEST)!,
	ADMINISTRATOR: USER_ROLES.find(
		(r) => r.name === USER_ROLE_NAMES.COMPANY_ADMIN
	)!,
} as const;
